import { render } from "./ProductRanking.vue?vue&type=template&id=41ad014c&scoped=true"
import script from "./ProductRanking.vue?vue&type=script&lang=js"
export * from "./ProductRanking.vue?vue&type=script&lang=js"

import "./ProductRanking.vue?vue&type=style&index=0&id=41ad014c&lang=scss&scoped=true"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ad014c"]])

export default __exports__